import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, emptyEnvelopeSchema, requiredPayloadEnvelope } from '../envelope.js';
import { realtimeNegotiateSchema } from '../common/schemas.js';
const c = initContract();
/**
 * admin-web 실시간 연결 — `admin` 허브. 이번 범위는 연결 인프라 스모크 검증까지만이고,
 * 실제 운영 메트릭 이벤트 스키마는 후속 과제다(`docs/_todos/observability.md` 참고).
 */
export const adminRealtimeContract = c.router({
    negotiate: {
        method: 'GET',
        path: '/realtime/negotiate',
        responses: {
            200: requiredPayloadEnvelope(realtimeNegotiateSchema),
            ...commonErrorResponses,
        },
    },
    /** 스모크 검증용 — `admin:smoke` 그룹에 더미 메시지를 발행해 연결 왕복을 눈으로 확인한다. */
    testPublish: {
        method: 'POST',
        path: '/realtime/test-publish',
        body: z.object({ message: z.string().min(1).max(200).optional() }),
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=realtime.contract.js.map